import {SubmissionError} from "redux-form";

export  function userMessage_throwErrorToFieldNamed(formFieldName, errorString )
{
    var SubmissionError_parameter = {};
    SubmissionError_parameter[formFieldName] = errorString;
    throw new SubmissionError( SubmissionError_parameter );
}

export  function userMessage_ok( title, text = "" )
{
    alert(title + "\n" + text);
}

export  function userMessage_error( title, text = "" )
{
    alert(title + "\n" + text);
}


// WEBPACK FOOTER //
// ./src/Atollon/messages/UserMessages.js